import { IndexTable, Text } from '@shopify/polaris';
import { useEffect, useState } from 'react';

const TransferAddStockTable = ({ product, transfer, onAddQty }) => {
  const headings = [{ title: '' }, ...product.variants.map((v) => ({ title: v.title })), { title: 'TOTAL' }] || [];
  const [transfered, setTransfered] = useState(initialTransfered(product));

  useEffect(() => {
    const qtys = product.variants
      .map(({ barcode }) => ({
        barcode,
        qty: transfered.find((d) => d.barcode === barcode)?.qty ?? 0,
      }))
      .filter(({ qty }) => qty !== 0);

    onAddQty(qtys);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product, transfered]);

  return (
    <IndexTable headings={headings} itemCount={3} selectable={false} lastColumnSticky={true}>
      <QtyDepositOriginStockRow deposit={transfer.originDeposit} product={product} transfered={transfered} />
      <QtyInputStockRow product={product} transfered={transfered} setTransfered={setTransfered} />
      <QtyDepositDestinationStockRow deposit={transfer.destinationDeposit} product={product} transfered={transfered} />
    </IndexTable>
  );
};

const initialTransfered = (product) =>
  product.variants.map(({ barcode }) => {
    return {
      qty: 0,
      barcode,
    };
  });

const QtyDepositOriginStockRow = ({ deposit, product, transfered }) => {
  return (
    <IndexTable.Row subdued selected={false}>
      <IndexTable.Cell>
        <Text alignment="start" variant="headingXs" fontWeight="bold">
          {deposit.name}
        </Text>
      </IndexTable.Cell>
      {stockAtDeposit(product, deposit).map((s, i) => (
        <IndexTable.Cell key={i}>
          <Text alignment="center" variant="headingXs" fontWeight="regular">
            {s.qty}{' '}
            {transfered.find((t) => t.barcode === s.barcode).qty > 0
              ? ' -> ' + (s.qty - transfered.find((t) => t.barcode === s.barcode).qty)
              : ''}
          </Text>
        </IndexTable.Cell>
      ))}
      <IndexTable.Cell>
        <Text alignment="center" variant="headingXs" fontWeight="bold">
          {stockAtDeposit(product, deposit).reduce((acc, cur) => acc + cur.qty, 0)}{' '}
          {transfered.reduce((acc, cur) => acc + cur.qty, 0)
            ? ' -> ' +
              (stockAtDeposit(product, deposit).reduce((acc, cur) => acc + cur.qty, 0) -
                transfered.reduce((acc, cur) => acc + cur.qty, 0))
            : ''}
        </Text>
      </IndexTable.Cell>
    </IndexTable.Row>
  );
};

const QtyInputStockRow = ({ product, transfered, setTransfered }) => {
  // const [qty, setQty] = useState(0);

  // const handleQtyChange = (e) => {
  //   const { value } = e.target;
  //   setQty(value);
  // };

  // const handleAddQty = (barcode) => {
  //   const newTransfered = transfered.map((t) => {
  //     if (t.barcode === barcode) {
  //       return {
  //         ...t,
  //         qty: t.qty + parseInt(qty),
  //       };
  //     }
  //     return t;
  //   });
  //   setTransfered(newTransfered);
  //   setQty(0);
  // };

  return (
    <IndexTable.Row subdued selected={false}>
      <IndexTable.Cell>
        <Text alignment="start" variant="headingXs" fontWeight="bold">
          TRANSFERENCIA
        </Text>
      </IndexTable.Cell>
      {product.variants
        .map((v) => transfered.find((d) => d.barcode === v.barcode))
        .map((d, i) => (
          <IndexTable.Cell key={i}>
            <input
              type="number"
              value={d.qty}
              style={{ width: '40px', borderBottom: '1px solid black', textAlign: 'center' }}
              onChange={(e) =>
                setTransfered([
                  ...transfered.filter((ps) => ps.barcode !== d.barcode),
                  {
                    barcode: d.barcode,
                    qty: e.target.value ? parseInt(e.target.value) : 0,
                  },
                ])
              }
            />
          </IndexTable.Cell>
        ))}
      <IndexTable.Cell>
        <Text alignment="center" variant="headingXs" fontWeight="bold">
          {transfered.reduce((acc, cur) => acc + cur.qty, 0)}
        </Text>
      </IndexTable.Cell>
    </IndexTable.Row>
  );
};

const QtyDepositDestinationStockRow = ({ deposit, product, transfered }) => {
  return (
    <IndexTable.Row subdued selected={false}>
      <IndexTable.Cell>
        <Text alignment="start" variant="headingXs" fontWeight="bold">
          {deposit.name}
        </Text>
      </IndexTable.Cell>
      {stockAtDeposit(product, deposit).map((s, i) => (
        <IndexTable.Cell key={i}>
          <Text alignment="center" variant="headingXs" fontWeight="regular">
            {s.qty}{' '}
            {transfered.find((t) => t.barcode === s.barcode).qty > 0
              ? ' -> ' + (s.qty + transfered.find((t) => t.barcode === s.barcode).qty)
              : ''}
          </Text>
        </IndexTable.Cell>
      ))}
      <IndexTable.Cell>
        <Text alignment="center" variant="headingXs" fontWeight="bold">
          {stockAtDeposit(product, deposit).reduce((acc, cur) => acc + cur.qty, 0)}{' '}
          {transfered.reduce((acc, cur) => acc + cur.qty, 0)
            ? ' -> ' +
              (stockAtDeposit(product, deposit).reduce((acc, cur) => acc + cur.qty, 0) +
                transfered.reduce((acc, cur) => acc + cur.qty, 0))
            : ''}{' '}
        </Text>
      </IndexTable.Cell>
    </IndexTable.Row>
  );
};

const stockAtDeposit = (product, deposit) =>
  product.variants.map((v) => {
    const s = product.stock.find((s) => v.barcode === s.barcode && s.deposit.id === deposit.id);
    return {
      qty: s ? s.qty : 0,
      barcode: v.barcode,
    };
  });

export default TransferAddStockTable;
